export default __webpack_public_path__ + "bbf27e12f1238838c371c05ba8dafdb5.svg";